import * as React from 'react';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Modal, Alert, DatePicker } from 'antd';
import { FormComponentProps } from '@ant-design/compatible/lib/form/Form';
import { connect } from 'react-redux';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import moment from 'moment';

const FormItem = Form.Item;
export const DATE_FORMAT = 'MMMM D, YYYY';
const disabledDate = (current) => {
	return current.isBefore(moment().startOf('day'));
};

interface EstimatedDateWorkOrderModalForm extends FormComponentProps {
	onSubmit: any;
	onCancel: any;
	createErrors: any;
	updateErrors: any;
	currentUser: any;
	visible: boolean;
	creating: boolean;
	updating: boolean;
	formData: any;
	fetchSupplierFacility: any;
	addWarrantySupplier: any;
}

class EstimatedDateWorkOrderModalForm extends React.Component<
	EstimatedDateWorkOrderModalForm,
	any
> {
	render() {
		const {
			visible,
			onCancel,
			onSubmit,
			form,
			formData,
			createErrors,
			updateErrors,
			creating,
			updating,
		} = this.props;
		const { getFieldDecorator } = form;
		const okText = 'Submit';
		const titleText = 'Edit Estimated Completion Date';

		getFieldDecorator(`id`, { initialValue: nullSafeGet('id', formData) });
		return (
			<Modal
				visible={visible}
				width={600}
				title={titleText}
				okText={okText}
				onCancel={onCancel}
				onOk={onSubmit}
				closable={false}
				confirmLoading={creating || updating}
			>
				<Form layout="vertical" className="supplierForm">
					{createErrors.length > 0 ? (
						<FormItem>
							<Alert message={createErrors.join(' ')} type="error" />
						</FormItem>
					) : null}
					{updateErrors.length > 0 ? (
						<FormItem>
							<Alert message={updateErrors.join(' ')} type="error" />
						</FormItem>
					) : null}
					<Form.Item required={true} label="Estimated Completion Date">
						{getFieldDecorator('estimatedCompletionDate', {
							rules: [
								{
									type: 'object',
									required: true,
									message: 'Please select a date',
								},
							],
							initialValue: formData.estimatedCompletionDate
								? moment(formData.estimatedCompletionDate)
								: undefined,
						})(
							<DatePicker
								disabledDate={disabledDate}
								style={{ width: '100%' }}
								showTime={false}
								format={DATE_FORMAT}
							/>
						)}
					</Form.Item>
				</Form>
			</Modal>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	visible: ownProps.visible,
	onCancel: ownProps.onCancel,
	onSubmit: ownProps.onSubmit,
	currentUser: state.session.currentUser,
	createErrors: state.buyer_contacts.createErrors,
	updateErrors: state.buyer_contacts.updateErrors,
	creating: state.work_orders.creating,
	updating: state.work_orders.updating,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Form.create<EstimatedDateWorkOrderModalForm>()(EstimatedDateWorkOrderModalForm));
